import { CalendarStatusLegend } from 'noddi-ui-web';
import { getCalendarStatusLegendItems } from '../../utils/fleetCalendarBookingDisplay';

/** The booking calendar's color key — the shared legend, with this app's status labels. */
export const BookingCalendarLegend = () => <CalendarStatusLegend items={getCalendarStatusLegendItems()} />;
